import InputGroup from "../InputGroup";
import {TextInput} from "omoplay";
import {useEffect, useState} from "react";
import {listKakaoGift} from "../../../api/benefit/benefit.api";

const BenefitKakaoSettings = ({ benefitName, kakaoGiftId, onChangeBenefitName, onSelected }) => {
    const [giftItems, setGiftItems] = useState([])

    useEffect(() => {
        listKakaoGift().then(({data}) => {
            setGiftItems(data)
        })
    }, []);

    return (
      <>
        <InputGroup label={(
            <div className="flex-col gap-2">
              <div>혜택 명</div>
            </div>
        )}>
          <TextInput value={benefitName}
                     onChange={(e) => onChangeBenefitName(e.target.value)}
                     maxLength={30}
          />
        </InputGroup>
        <InputGroup label={(
            <div className="flex-col gap-2">
              <div>카카오 교환권 선택</div>
            </div>
        )}>
            <div className="flex flex-wrap">
                {
                    giftItems.map(gift => {
                        return (
                            <div className={`w-fit p-[24px] pointer ${(kakaoGiftId === gift.id && "border border-[#4046e3]")}`} onClick={() => onSelected(gift.id)}>
                                <img src={gift.imgUrl} width={250} height={250} />
                                <div>
                                    <div className="text-[20px] font-semibold">{gift.name}</div>
                                    <div>{gift.option}</div>
                                    <div className="text-[20px] font-semibold">{gift.price.toLocaleString()}원</div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </InputGroup>
      </>
    )
};

export default BenefitKakaoSettings;
